<template>
  <div id="app">
    <Toasts />
    <transition name="fade">
      <div id="overlay" v-if="panelCount > 0" @click="removeAllPanels"></div>
    </transition>
    <Navigation />
    <router-view />
  </div>
</template>

<script>
import Navigation from "@/components/Navigation";
import Toasts from "@/components/Toasts";

export default {
  components: {
    Navigation,
    Toasts
  },
  computed: {
    panelCount() {
      return this.$store.getters.sidepanelCount;
    }
  },
  watch: {
    $route(to, from) {
      this.removeAllPanels();
    }
  }
};
</script>
<style lang="less">
@import "./styles/app";
@import "./styles/baseform.less";
</style>
